import { useEffect, useRef, useState } from 'preact/hooks';

/** 忙碌提示闪现时长 */
const BUSY_HINT_MS = 2500;

/**
 * 「点击忙碌中的发送按钮 → 闪现提示」共用 hook(web/数字人面板)。
 *
 * AI 回合进行中发送按钮不锁定点击(原生 disabled 不触发 click,无法给反馈),
 * 而是视觉禁用 + 点击/回车时调 flash() 在按钮上方弹小气泡提示(.dcs-send-busy-tip),
 * BUSY_HINT_MS 后自动隐藏;回合结束渲染层随 aiBusy 解除立即收起。
 */
export function useBusyHint(): { visible: boolean; flash: () => void } {
  const [visible, setVisible] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const flash = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setVisible(true);
    timerRef.current = setTimeout(() => {
      setVisible(false);
      timerRef.current = null;
    }, BUSY_HINT_MS);
  };

  useEffect(
    () => () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    },
    [],
  );

  return { visible, flash };
}
